<div *ngIf="gallery" [id]="slideType" class="gallery-top" [ngClass]="{'overflow': slideType=='leaderboard'}">
  <div class="content">
    <ngx-glide [animationTimingFunc]="'ease-in-out'"
              [showArrows]="gallery?.length > 1 ? true : false"
              [showBullets]="false"
              [hoverpause]="true"
              [animationDuration]="250"
              [perView]="1"
              [autoplay]="gallery?.length > 1 && autoSlide ? 3000 : false"
              [arrowLeftLabel]="''"
              [arrowRightLabel]="''"
              type="carousel"
            >
      <div [id]="'lightgallery' + slideType" class="" *ngFor="let slide of gallery; let i = index; trackBy: trackByFn">
        <span class="swiper-slide img-container">
          <!-- For images -->
          <img 
            loading="lazy"
            [hidden]="slide.media_type==='video'" 
            [class]="'img ' + (slideType ? slideType: '')" 
            [ngClass]="{'blur-image':(vwo.story_blur_image_ABC() ==='GLOBAL' && vars?.blur_image) || vwo.story_blur_image_ABC() ==='INDIVIDUAL' && vars?.blur_image}"
            [attr.data-src]="slide.cdn_path" 
            [alt]="'Fundraiser Leaderboard'+i" />
          <!-- blur-btn -->
            <button *ngIf="vwo.story_blur_image_ABC() === 'INDIVIDUAL' && vars?.blur_image" class="blur-btn" (click)="toggleBlur()" mat-icon-button>
              <mat-icon>visibility</mat-icon>&nbsp;Show photos
            </button>
            <button *ngIf="vwo.story_blur_image_ABC() === 'INDIVIDUAL' && !vars?.blur_image" class="blur-btn" (click)="toggleBlur()" mat-icon-button>
              <mat-icon>visibility_off</mat-icon>&nbsp;Hide photos
            </button>
          <!-- For Youtube video -->
          <img loading="lazy" [hidden]="!(slide.media_type=='video' && !slide?.showVideo)" [class]="'img ' + (slideType ? slideType: '')"
            [attr.data-src]="slide.cdn_path" (click)="addYoutubeEmbed(slide)"
            [alt]="'Fundraiser Leaderboard Youtube Video'+i" />
          <i *ngIf="slide.media_type=='video' && !slide?.showVideo" class="icon-youtube1"
          (click)="addYoutubeEmbed(slide)"></i>
          <!-- Youtube embed -->
          <iframe *ngIf="slide.media_type=='video' && slide?.showVideo" class="youtube-embed b-lazy" [ngClass]="slideType" type="text/html" allow="autoplay" [src]="slide?.videoSrc"></iframe>
          <!-- Under line shadow -->
          <div *ngIf="shadow" class="image-shadow" [ngClass]="{'videos': slide.media_type === 'video'}" [attr.data-bg]="slide.cdn_path"></div>
          <!-- Fundraiser Short Description for desktop-->
          <div class="fr-short-description">
            <div>{{fundraiser?.title}}</div>
          </div>
        </span>
      </div>
    </ngx-glide>
  </div>
</div>
